import { Component, computed, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

const EXPIRES_IN = 5;
const SECONDS_IN_MINUTE = 60;
const MILLIS_IN_SECOND = 1000;

@Component({
	selector: 'nta-inactive-warning',
	templateUrl: './inactive-warning.dialog.html',
	styleUrls: ['./inactive-warning.dialog.scss'],
	imports: [MatDialogModule, MatButtonModule]
})
export class InactiveWarningDialog implements OnDestroy, OnInit {
	private dialogRef = inject<MatDialogRef<InactiveWarningDialog>>(MatDialogRef);


	seconds = EXPIRES_IN;

	timeout: ReturnType<typeof setTimeout>;

	timeLeft = signal(EXPIRES_IN);

	readableTimeLeft = computed(() => this.timeLeft() === 1 ? `${this.timeLeft()} minute` : `${this.timeLeft()} minutes`);

	interval: ReturnType<typeof setInterval>;

	ngOnInit() {
		this.interval = setInterval(() => {
			this.timeLeft.update((time) => time - 1);
		}, MILLIS_IN_SECOND * SECONDS_IN_MINUTE);
		this.timeout = setTimeout(() => {
			this.dialogRef.close(false);
		}, MILLIS_IN_SECOND * SECONDS_IN_MINUTE * EXPIRES_IN);
	}

	ngOnDestroy() {
		clearTimeout(this.timeout);
		clearInterval(this.interval);
	}
}
